import { Item } from "react-stately";
import { navigate } from "gatsby";

import Select from "@core/ui/molecules/select/Select";
import { useCountry } from "@func-core/core/application/hooks/useCountry";
import { CountrySource, createCountryViewModel } from "@func-core/core/domain/view-models";
import { CountryCode, CountrySubsetConfiguration } from "@settings/countries";
import { homePath, launchedCountries } from "@utils/locale-configuration-utils";

const CountrySwitch = (): JSX.Element => {
  const countries: CountrySubsetConfiguration[] = launchedCountries;
  const { country, setCountryState } = useCountry();

  const handleGoToCountryHome = (countryCode: string): void => {
    const countryViewModel = createCountryViewModel({
      iso: countryCode,
      source: CountrySource.USER_SELECTION,
    });

    setCountryState(countryViewModel.country, countryViewModel.source);

    void navigate(homePath(countryCode as CountryCode));
  };

  return (
    <Select
      label="Country"
      adoptionClassName="ml-country-switch"
      items={countries}
      selectedKey={country?.iso}
      onSelectionChange={(selected) => handleGoToCountryHome(selected as string)}
    >
      {(item: CountrySubsetConfiguration) => (
        <Item key={item.countryCode} textValue={item.name}>
          {item.name}
        </Item>
      )}
    </Select>
  );
};

export default CountrySwitch;
